// extracted by mini-css-extract-plugin
export var blockContent = "editorial-module--blockContent--fe895";
export var hubspotFormColor = "editorial-module--hubspotFormColor--91f00";
export var hubspotFormContainer = "editorial-module--hubspotFormContainer--16daa";
export var postHeadline = "editorial-module--postHeadline--ab0a9";
export var styledPost = "editorial-module--styledPost--d4178";